import SecondaryCtaType from '~/constants/SecondaryCtaType';
import { useConfiguration } from '~/context/common/StaticContext';
import useSecondaryCtaButtonState from './useSecondaryCtaButtonState';

export default function useSecondaryCtaButtonCopy(): string | null {
  const { shouldUseTitleCasing } = useConfiguration();
  const { type } = useSecondaryCtaButtonState();

  const secondaryCtaTypes: Record<SecondaryCtaType, string | null> = {
    [SecondaryCtaType.Default]: null,
    [SecondaryCtaType.GetAlerts]: shouldUseTitleCasing
      ? 'Get Alerts'
      : 'Get alerts',
    [SecondaryCtaType.NotifyMe]: shouldUseTitleCasing
      ? 'Notify Me'
      : 'Notify me',
    [SecondaryCtaType.ViewMoreCars]: shouldUseTitleCasing
      ? 'View More Cars'
      : 'View more cars',
    [SecondaryCtaType.ViewSimilarVehicles]: shouldUseTitleCasing
      ? 'View Similar Vehicles'
      : 'View similar vehicles'
  };

  return secondaryCtaTypes[type];
}
